module.exports = __webpack_public_path__ + "img/armando-01.0fcec698.png";